import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function AddDocumentReviewNoteReducer(
	state = initialState.newDocumentReviewNote,
	action
) {
	if (action.entityType == 'document') {
		switch (action.type) {
			case types.CREATE_REVIEW_NOTE: {
				return {priority: 1, fromUser: action.data};
			}
			case types.CLEAR_NEW_REVIEW_NOTE: {
				return {};
			}
			case types.SELECT_REVIEW_NOTE_FROM_USER: {
				return {...state, fromUser: action.data};
			}
			case types.SELECT_REVIEW_NOTE_TO_USER: {
				return {...state, toUser: action.data};
			}
			case types.SELECT_REVIEW_NOTE_PRIORITY: {
				return {...state, priority: action.data};
			}
			case types.SELECT_REVIEW_NOTE_DUE_DATE: {
				return {...state, dueDate: action.data};
			}
			case types.UPDATE_REVIEW_NOTE_TEXT: {
				return {...state, comments: action.data};
			}
			case types.CLEAR_EDIT_REVIEW_NOTE_ERROR: {
				let old = state;
				if (old.isNoteEditorOpened) {
					return {...state, isNoteEditorOpened: false};
				}
				return {...state};
			}
			case types.SHOW_EDIT_REVIEW_NOTE_ERROR: {
				let old = state;
				if (!old.isNotEditorOpen) {
					return {...state, isNoteEditorOpened: true};
				}
				return {...state};
			}
			default:
				return state;
		}
	}
	return state;
}
